import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { AUTH_CONFIG, ErrorLoggerService, TokenInterceptor } from '@ec/authentication';
import { DYNAMIC_FORM_COMPONENT_MAP } from '@elemental-concept/dynamic-form';
import { materialComponentMap } from '@elemental-concept/dynamic-form-material';
import { bakeEnv } from '@elemental-concept/env-bakery';
import { GrappaModule } from '@elemental-concept/grappa';
import { GrappaJwtModule } from '@elemental-concept/grappa-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { RoleType } from './app/modules/auth/types';
import { CustomErrorLoggerService, CustomTranslationLoader } from './app/modules/communication/services';

export function HttpLoaderFactory() {
  return new CustomTranslationLoader();
}

bakeEnv(() => import('./environments/environment'))
  .then(environment => {
    bootstrapApplication(AppComponent, {
      providers: [
        provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),

        provideAnimationsAsync(),

        importProvidersFrom(GrappaModule),
        importProvidersFrom(GrappaJwtModule),

        importProvidersFrom(TranslateModule.forRoot({
          fallbackLang: 'en',
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpBackend]
          }
        })),

        { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd/MM/yyyy' } },

        // Dynamic Form mapping object using Dynamic Form Material map
        { provide: DYNAMIC_FORM_COMPONENT_MAP, useValue: materialComponentMap },

        // set the default for the snack bar
        {
          provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
          useValue: {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          }
        },

        // Point interceptor to Auth Library service
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        },

        // Auth Config to bootstrap the library
        {
          provide: AUTH_CONFIG,
          useValue: {
            guestRole: RoleType.guest,
            rootUrl: '/auth/login',
            changePasswordUrl: '/auth/change-password',
            landingPages: {
              [RoleType.customer]: '/customer',
              [RoleType.guest]: '/public'
            },
            authApiUrl: `${environment.apiUrl}`,
            baseApiUrl: `${environment.apiUrl}`
          }
        },

        // Datepicker config
        {
          provide: MAT_DATE_FORMATS,
          useValue: {
            display: {
              dateInput: 'DD/MM/YYYY',
              monthYearLabel: 'MMM YYYY',
              dateA11yLabel: 'LL',
              monthYearA11yLabel: 'MMMM YYYY'
            }
          }
        },

        { provide: ErrorLoggerService, useClass: CustomErrorLoggerService }
      ]
    });
  })
  .catch(err => console.error(err));
